import React, { useEffect, useState } from 'react';
import { Pagination, Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { getShopMeReward } from '../../servies/shop';
import { Reward } from '../../types/Reward';
import moment from 'moment';
type Props = {};
// interface DataType {
//   key: string;
//   name: string;
//   age: number;
//   address: string;
//   tags: string[];
// }
interface DataTableType {
  key: string;
  img: string;
  descriptionShort: string;
  description: string;
  amount: number;
  branches: string[];
  usableSince: string;

  usableUntil: string;
}

const columns: ColumnsType<DataTableType> = [
  {
    title: 'No.',
    dataIndex: 'key',
    key: 'No',
    width: 60,
    render: (text) => <div>{text}</div>,
  },
  {
    title: 'ภาพแบนเนอร์',
    dataIndex: 'img',
    key: 'img',
    width: 150,
    render: (text) => (
      <img width="76px" alt="img" height="50px" src={text}></img>
    ),
  },
  {
    title: 'คำอธิบายย่อ',
    dataIndex: 'descriptionShort',
    key: 'descriptionShort',
    width: 150,
    render: (text) => <div>{text}</div>,
  },
  {
    title: 'คำอธิบายโดยละเอียด',
    dataIndex: 'description',
    key: 'description',
    width: 200,
    render: (text) => <div>{text}</div>,
  },
  {
    title: 'จำนวนคูปองที่ใช้ได้ต่อบิล',
    dataIndex: 'amount',
    key: 'amount',
    width: 200,
    render: (text) => <div>{text}</div>,
  },
  {
    title: 'สาขาที่ร่วมรายการ',
    dataIndex: 'branches',
    key: 'branches',
    width: 200,
    render: (_, { branches }) => (
      <>
        {branches.map((branches) => {
          return <div>● {branches}</div>;
        })}
      </>
    ),
  },
  {
    title: 'ระยะเวลาการแลก',
    dataIndex: 'usableSince',
    key: 'usableSince',
    width: 150,

    render: (text) => <div>{moment(text).format('DD/MM/YYYY')}</div>,
  },
  {
    title: 'ระยะเวลาการใช้',
    dataIndex: 'usableUntil',
    key: 'usableUntil',
    width: 150,
    render: (text) => <div> {moment(text).format('DD/MM/YYYY')}</div>,
  },
];

// const data: DataTableType[] = [
//   {
//     key: '1',
//     img: 'John Brown',
//     descriptionShort: 'New York No. 1 Lake Park',
//     description: 'New York No. 1 Lake Park',
//     amount: 32,
//     branches: ['zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzz', 'teacher'],
//     usableSince: 'New York No. 1 Lake Park',

//     usableUntil: 'New York No. 1 Lake Park',
//   },
// ];

const RewardComponent = (props: Props) => {
  const [dataTable, setDataTable] = useState<DataTableType[]>();
  const [totalData, setTotalData] = useState<number>(0);
  useEffect(() => {
    fetchData(1);
  }, []);

  async function fetchData(page: number) {
    let res = await getShopMeReward(page);
    let _resArray: DataTableType[] = [];
    let resJson: Reward = JSON.parse(res.data);
    setTotalData(resJson.total);
    resJson.data.forEach((data) => {
      _resArray.push({
        key: data.no.toString(),
        img: data.bannerImage,
        descriptionShort: data.shortDesc,
        description: data.desc,
        amount: data.currentAmount,

        branches: data.availableAt,
        usableSince: data.usableSince,

        usableUntil: data.usableUntil,
      });
    });
    console.log('_resArray', _resArray);

    setDataTable([..._resArray]);
    console.log('res', JSON.parse(res.data));
  }
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
      <div className="header-component">รายการรีวอร์ด</div>
      <div>
        <Table
          columns={columns}
          pagination={false}
          dataSource={dataTable}
          scroll={{ y: 450 }}
          className="table-reward"
          indentSize={2}
        />
      </div>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        {' '}
        <Pagination
          defaultCurrent={1}
          total={totalData}
          onChange={(e) => fetchData(e)}
          pageSize={window.innerHeight < 700 ? 3 : 5}
        />
      </div>
    </div>
  );
};

export default RewardComponent;
